const locale = require('./rateStatusRow.i18n.json');
/*@ngInject*/
const RateStatusRowController = function ($rootScope, $scope, $element, $timeout, dateUtil,
                                          localization, formComponentUtil, configurationConstant) {

    this.$onInit = function () {
        this.i18n = locale;
        this.effectiveDate = _.isNil(this.item.effectiveDateRangeBegin) ? '' : this.formatUTCDateString(this.item.effectiveDateRangeBegin);
        this.expirationDate = _.isNil(this.item.effectiveDateRangeEnd) ? '' : this.formatUTCDateString(this.item.effectiveDateRangeEnd);

        this.productDropdownSelectedValue = {
            name: this.item.productTemplateShortName,
            value: this.item.productTemplateShortName
        };
        this.productClassName = _.camelCase(this.item.productTemplateShortName);
        this.startEffectivePopupOpen = false;
        this.startExpirationPopupOpen = false;
        this.isError = false;
        this.isEmptyRow = true;
        this.rowSelected = false;
        this.checkValidation();
    };

    this.$onChanges = function () {

        this.statusSelectedValue = {name: this.item.status, value: this.item.status};
        _.each(this.statuses, (status) => {
            if (parseInt(status.value) === this.item.status) {
                this.statusSelectedValue = {name: status.name, value: status.value};
                this.statusClassName = _.camelCase(status.name);
            }
        });

        if(!_.isNil(this.locations)) {
            this.locationSelectedValue = {
                name: this.item.state,
                value: this.item.state
            };
            _.each(this.locations, (location) => {
                if(location.value === this.item.state) {
                    this.locationSelectedValue = {
                        name: location.name,
                        value: location.value
                    };
                    this.locationClassName = _.camelCase(location.name);
                }
            });
        }
    };

    this.getLocationSelectedValue = function () {
        _.each($scope.viewModel.locations, (location) => {
            if(location.id === stateRate.id) {
                matchIndex = count + 1;
                return;
            }
            count++;
        });
    };

    this.checkValidation = function () {
        if (_.isNil(formComponentUtil.dateFromInput(this.effectiveDate, false)) &&
            _.isNil(formComponentUtil.dateFromInput(this.expirationDate, false)) &&
            _.isNil(this.item.productTemplateShortName) &&
            _.isNil(this.item.status) &&
            _.isNil(this.item.state)) {
            this.isError = false;
        } else if (!_.isNil(formComponentUtil.dateFromInput(this.effectiveDate, false)) && !_.isEmpty(this.effectiveDate) &&
                    !_.isNil(formComponentUtil.dateFromInput(this.expirationDate, false)) && !_.isEmpty(this.expirationDate) &&
                    !_.isNil(this.item.productTemplateShortName) && !_.isEmpty(this.item.productTemplateShortName) &&
                    !_.isNil(this.item.status) && this.item.status !== '' &&
                    !_.isNil(this.item.state) && !_.isEmpty(this.item.state)) {
            this.isError = false;
            this.isEmptyRow = false;
        } else {
            this.isError = true;
            this.isEmptyRow = false;
        }

        if(dateUtil.isAfter(this.effectiveDate,this.expirationDate)) {
            this.isError = true;
        }
    };

    this.onLocationValueChange = function (option) {
        this.item.state = option.value;
        this.locationSelectedValue = {
            name: option.name,
            value: option.value
        };
        this.locationClassName = _.camelCase(option.name);
        this.checkValidation();
        this.hasUnsavedChanges = true;
        this.validateAction();
    };

    this.onProductValueChange = function (option) {
        this.item.productTemplateShortName = option.value;
        this.productDropdownSelectedValue = {
            name: this.item.productTemplateShortName,
            value: this.item.productTemplateShortName
        };
        this.productClassName = _.camelCase(this.item.productTemplateShortName);
        this.checkValidation();
        this.hasUnsavedChanges = true;
        this.validateAction();
    };

    this.onStatusValueChange = function (option) {
        this.item.status = parseInt(option.value);

        _.each(this.statuses, (status) => {
            if (parseInt(status.value) === this.item.status) {
                this.statusSelectedValue = {name: status.name, value: status.value};
                this.statusClassName = _.camelCase(status.name);
            }
        });
        this.checkValidation();
        this.hasUnsavedChanges = true;
        this.validateAction();
    };

    this.handleChange = function (event) {
        let isDaySelected = event ? $(event.target).parents('.uib-day').length > 0 : false;

        if (isDaySelected) {
            if (this.startEffectivePopupOpen) {
                this.effectiveDate = dateUtil.formatDate(this.selectedDate, false);
            }
            if (this.startExpirationPopupOpen) {
                this.expirationDate = dateUtil.formatDate(this.selectedDate, false);
            }
            this.checkValidation();
            this.startEffectivePopupOpen = false;
            this.startExpirationPopupOpen = false;
            if (this.effectiveDate !== '') {
                this.item.effectiveDateRangeBegin = this.parseDateToMilliseconds(this.effectiveDate);
            }
            if (this.expirationDate !== '') {
                this.item.effectiveDateRangeEnd = this.parseDateToMilliseconds(this.expirationDate);
            }
            this.hasUnsavedChanges = true;
            this.validateAction();
        }
    };

    this.parseDateToMilliseconds = function (date) {
        let dateTimezoneOffset = '+0000',
         newDate = moment(date+dateTimezoneOffset, 'MM/DD/YYYYZZ');
        return newDate.valueOf();
    };

    this.formatUTCDateString = function(date) {
        let momentDate = moment.utc(new Date(date)),
            isValidDate = momentDate.isValid(),
            dateString = isValidDate ? momentDate.format('MM/DD/YYYY') : ' ';
        return dateString;
    };

    this.handleBlur = function () {
        this.checkValidation();
    };

    this.onEffectiveDateChange = function () {
        if(_.isEmpty(this.effectiveDate)) {
            this.item.effectiveDateRangeBegin = null;
        } else {
            this.item.effectiveDateRangeBegin = this.parseDateToMilliseconds(this.effectiveDate);
        }
        this.checkValidation();
        this.hasUnsavedChanges = true;
        this.validateAction();
    };

    this.onExpirationDateChange = function () {
        if(_.isEmpty(this.expirationDate)) {
            this.item.effectiveDateRangeEnd = null;
        } else {
            this.item.effectiveDateRangeEnd = this.parseDateToMilliseconds(this.expirationDate);
        }
        this.checkValidation();
        this.hasUnsavedChanges = true;
        this.validateAction();
    };

    this.handleEffectiveClick = function () {
        this.startEffectivePopupOpen = true;
        this.startExpirationPopupOpen = false;
        this.selectedDate = this.effectiveDate;
    };

    this.handleExpirationClick = function () {
        this.startEffectivePopupOpen = false;
        this.startExpirationPopupOpen = true;
        this.selectedDate = this.expirationDate;
    };

    this.onEffectiveDateClick = function () {
        this.startEffectivePopupOpen = false;
        this.startExpirationPopupOpen = false;
    };
    this.onExpirationDateClick = function () {
        this.startEffectivePopupOpen = false;
        this.startExpirationPopupOpen = false;
    };

    this.onDelete = function () {
        if (this.isEmptyRow) {
            this.locationSelectedValue = {};
            this.productDropdownSelectedValue = {};
            this.statusSelectedValue = {};
            this.expirationDate = null;
            this.effectiveDate = null;
            this.item.productTemplateShortName = null;
            this.item.status = null;
            this.item.state = null;
            this.checkValidation();
            this.isError = true;
            this.hasUnsavedChanges = true;
            this.validateAction();
        } else {
            $rootScope.$broadcast(configurationConstant.event.STATE_RATE_DELETED, this.item.id);
        }
    };

    this.onCopy = function () {
        this.isEmptyRow = false;
        $rootScope.$broadcast(configurationConstant.event.STATE_RATE_COPY, this.item);
    };

    this.handleClose = function () {
        this.startEffectivePopupOpen = false;
        this.startExpirationPopupOpen = false;
        this.rowSelected = false;
    };

    this.changeState = function () {
        this.rowSelected = !this.rowSelected;
    };

    this.setDefaultState = function () {
        this.rowSelected = false;
        this.handleClose();
    };

    this.setError = function () {
        this.isError = !this.isError;
    };
};

angular.module('ums.configuration')
    .controller('rateStatusRowController', RateStatusRowController);

